import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";

function Prevention() {
  const preventionRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -20px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('Adding animate-in to Prevention:', entry.target.className);
          entry.target.classList.add('animate-in');
        } else {
          console.log('Removing animate-in from Prevention:', entry.target.className);
          entry.target.classList.remove('animate-in');
        }
      });
    }, observerOptions);

    if (preventionRef.current) {
      observer.observe(preventionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section ref={preventionRef} className="prevention-section scroll-animate">
      <Container>
        <div className="prevention-content">
          <h2 className="prevention-main-title">유지보수</h2>
          <p className="prevention-main-description">
            유지보수는 크게 <strong>예방 유지보수</strong>와<br className="mobile-line-break"/> <strong>수리 유지보수</strong>로 나눌 수 있습니다.
          </p>

          <Row className="prevention-categories">
            <Col md={6}>
              <div className="prevention-category">
                <h3 className="prevention-category-title">예방 유지보수</h3>
                <p className="prevention-category-description">
                  정기적으로 HVAC 시스템을 점검, 관리하여 <br className="tablet-line-break"/>고장을 예방하는 것이 목적입니다.
                </p>
                <div className="prevention-items">
                  <div className="prevention-item">
                    <h4>필터 점검 및 교체</h4>
                    <p>먼지나 오염물질이 쌓이면 <br className="mobile-line-break"/>시스템 효율이 떨어지므로, <br className="tablet-line-break"/>정기적 점검과 교체가 필요</p>
                  </div>
                  <div className="prevention-item">
                    <h4>냉매 압력 확인</h4>
                    <p>냉매가 부족하면 시스템이 <br className="mobile-line-break"/>제대로 작동하지 않으므로, <br className="tablet-line-break"/>압력 체크 후 필요 시 보충</p>
                  </div>
                  <div className="prevention-item">
                    <h4>배관 점검</h4>
                    <p>배수 라인이나 냉매 배관이 <br className="mobile-line-break"/>막히거나 손상되지 않도록 점검</p>
                  </div>
                  <div className="prevention-item">
                    <h4>실외기 청소</h4>
                    <p>실외기의 열교환기가 막히지 않도록<br className="tablet-line-break"/> 주기적으로 청소하고, 부식 여부를 점검</p>
                  </div>
                  <div className="prevention-item">
                    <h4>팬 및 모터 점검</h4>
                    <p>송풍팬의 소음이나 작동 불량을 점검하고, <br className="tablet-line-break"/>모터의 상태를 확인</p>
                  </div>
                  <div className="prevention-item">
                    <h4>온도 센서 및 제어 시스템 점검</h4>
                    <p>온도 센서가 정확하게 작동하는지,<br className="mobile-line-break"/> <br className="tablet-line-break"/>제어 시스템이 정상적인지 확인</p>
                  </div>
                </div>
              </div>
            </Col>

            <Col md={6}>
              <div className="prevention-category">
                <h3 className="prevention-category-title">수리 유지보수</h3>
                <p className="prevention-category-description">
                  시스템에 문제가 발생했을 때 <br className="tablet-line-break"/>고치거나 부품을 교체하는 작업입니다.
                </p>
                <div className="prevention-items">
                  <div className="prevention-item">
                    <h4>부품 교체</h4>
                    <p>고장난 컴프레서, 팬 모터, 밸브 등의<br className="tablet-line-break"/> 핵심 부품을 새 부품으로 교체</p>
                  </div>
                  <div className="prevention-item">
                    <h4>냉매 누수 수리</h4>
                    <p>냉매 배관의 균열이나 연결부 손상으로 인한 <br className="tablet-line-break"/>누수를 찾아 수리하고 냉매 재충전</p>
                  </div>
                  <div className="prevention-item">
                    <h4>전기 계통 수리</h4>
                    <p>단선, 접촉 불량, 릴레이 고장 등<br className="tablet-line-break"/> 전기적 문제를 진단하고 수리</p>
                  </div>
                  <div className="prevention-item">
                    <h4>열교환기 수리</h4>
                    <p>증발기나 응축기의 막힘이나 손상을<br className="tablet-line-break"/> 청소 또는 수리하여 성능 복구</p>
                  </div>
                  <div className="prevention-item">
                    <h4>배관 보수</h4>
                    <p>손상된 배수관이나 냉매 배관을 <br className="tablet-line-break"/>용접, 교체하여 시스템 정상화</p>
                  </div>
                  <div className="prevention-item">
                    <h4>제어 시스템 수리</h4>
                    <p>온도 조절기, 압력 스위치, 센서 등 <br className="tablet-line-break"/>제어 장치의 오작동을 수리</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Prevention;
